import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';
import { Constants } from '../../shared/Constants';

@Injectable()
export class ApprobationService {

  constructor(private http: HttpClient) { }

  getAprobbations() {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/GrupoAprobacion', { headers: headers });
  }
  getTipoDocumento() {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/tipo_aprobacion', { headers: headers });
  }
  createGroup(body) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.post(Constants.URL_BACKEND + '/GrupoAprobacion', {body}, { headers: headers });
  }
  getUserGroupAprobation(id) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
   const params = new HttpParams().set('idGrupo', id);
    return this.http.get(Constants.URL_BACKEND +'/UsuarioGrupoAprobacion/', { headers: headers,params:params });
  }
  getInfoGroupAprobation(id) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND +'/GrupoAprobacion/'+id, { headers: headers });
  }

  deleteGroup(id) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.delete(Constants.URL_BACKEND +'/GrupoAprobacion/'+id, { headers: headers });
  }
  
  updateGroup(body) {
    console.log("body->",body);
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.put(Constants.URL_BACKEND +'/GrupoAprobacion/'+body.id,body, { headers: headers });
  }
}



// WEBPACK FOOTER //
// ./src/app/system/services/approbation.service.ts